export enum ChartType {
  bar = 'bar',
  line = 'line',
  lineStacked = 'lineStacked',
  pie = 'pie',
}
